<form [formGroup]="authForm.form">
  <section formGroupName="subscriber">
    <h5>{{ 'prior-authorization.form.subscriber' | translate }}</h5>

    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'lastName', formGroup: authForm.form.get('subscriber') } }"></ng-template>
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'firstName', formGroup: authForm.form.get('subscriber') } }"></ng-template>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'middleName', formGroup: authForm.form.get('subscriber') } }"></ng-template>
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'suffix', formGroup: authForm.form.get('subscriber') } }"></ng-template>
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'memberId', formGroup: authForm.form.get('subscriber') } }"></ng-template>
    </div>
  </section>

  <section formGroupName="patient">
    <h5>{{ 'prior-authorization.form.patient' | translate }}</h5>

    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'lastName', formGroup: authForm.form.get('patient') } }"></ng-template>
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'firstName', formGroup: authForm.form.get('patient') } }"></ng-template>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'middleName', formGroup: authForm.form.get('patient') } }"></ng-template>
      <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'suffix', formGroup: authForm.form.get('patient') } }"></ng-template>
      <ng-template *ngTemplateOutlet="dateField; context: { $implicit: { prop: 'birthDate', formGroup: authForm.form.get('patient') } }"></ng-template>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
      <ng-template
        *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'subscriberRelationshipCode', formGroup: authForm.form.get('patient'), codeValueMap: authForm.patientCodeValueMap } }">
      </ng-template>
      <ng-template
        *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'genderCode', formGroup: authForm.form.get('patient'), codeValueMap: authForm.patientCodeValueMap } }">
      </ng-template>
    </div>
    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'statusCode', formGroup: authForm.form.get('patient'), codeValueMap: authForm.patientCodeValueMap } }">
    </ng-template>
    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'conditionCode', formGroup: authForm.form.get('patient'), codeValueMap: authForm.patientCodeValueMap } }">
    </ng-template>
    <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'medicareCoverage', formGroup: authForm.form.get('patient') } }"></ng-template>
    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'prognosisCode', formGroup: authForm.form.get('patient'), codeValueMap: authForm.patientCodeValueMap } }">
    </ng-template>
  </section>

  <section formArrayName="diagnoses">
    <h5>{{ 'prior-authorization.form.diagnoses' | translate }}</h5>

    <ng-container *ngFor="let diagnosisForm of authForm.diagnoses.controls; let i = index">
      <section [formGroup]="diagnosisForm">
        <div class="subtitle-wrapper">
          <h6>{{ 'prior-authorization.form.diagnosis' | translate }} {{ i + 1 }}</h6>
          <button *ngIf="i !== 0" mat-icon-button color="warn" (click)="authForm.deleteDiagnosis(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'code', formGroup: diagnosisForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="dateField; context: { $implicit: { prop: 'date', formGroup: diagnosisForm } }"></ng-template>
      </section>
    </ng-container>

    <div *ngIf="authForm.canAddDiagnosis && !readonlyMode" class="add-wrapper">
      <button
        mat-mini-fab
        color="primary"
        (click)="authForm.addDiagnosesRow()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </section>

  <div fxLayout="row wrap">
    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'requestTypeCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
    </ng-template>
    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'serviceTypeCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
    </ng-template>

    <section *ngIf="authForm.form.contains('additionalServiceTypes')" formArrayName="additionalServiceTypes">
      <h5>{{ 'prior-authorization.form.additionalServiceTypes' | translate }}</h5>
      <ng-container *ngFor="let serviceTypeForm of authForm.additionalServiceTypes.controls; let i = index">
        <section class="additonal-service-type" [formGroup]="serviceTypeForm">
          <mat-form-field appearance="fill">
            <mat-label>
              {{ 'prior-authorization.form.serviceTypeCode' | translate }} {{ i + 1 }}
            </mat-label>
            <mat-select formControlName="code">
              <mmx-searchable-select>
                <mat-option *ngFor="let value of authForm.additionalServiceTypesCodeValues" [value]="value.code">
                  {{ value.value }}
                </mat-option>
              </mmx-searchable-select>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button color="warn" (click)="authForm.deleteAdditionalServiceType(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </section>
      </ng-container>

      <div *ngIf="authForm.canAddAdditionalServiceTypes && !readonlyMode" class="add-wrapper">
        <button
          mat-mini-fab
          color="primary"
          (click)="authForm.addAdditionalServiceTypeRow()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </section>

    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'placeOfServiceCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
    </ng-template>
    <ng-template
      *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'serviceLevelCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
    </ng-template>
  </div>

  <ng-template *ngTemplateOutlet="dateField; context: { $implicit: { prop: 'fromDate', formGroup: authForm.form } }"></ng-template>
  <ng-template *ngTemplateOutlet="dateField; context: { $implicit: { prop: 'toDate', formGroup: authForm.form } }"></ng-template>
  <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'quantity', formGroup: authForm.form } }"></ng-template>
  <ng-template
    *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'quantityTypeCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
  </ng-template>
  <ng-template
    *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'admissionTypeCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
  </ng-template>
  <ng-template
    *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'admissionSourceCode', formGroup: authForm.form, codeValueMap: authForm.codeValueMap } }">
  </ng-template>
  <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'chiropracticTreatmentCount', formGroup: authForm.form } }"></ng-template>

  <section formArrayName="procedures">
    <h5>{{ 'prior-authorization.form.procedures' | translate }}</h5>

    <ng-container *ngFor="let procedureForm of authForm.procedures.controls; let i = index">
      <section [formGroup]="procedureForm">
        <div class="subtitle-wrapper">
          <h6>{{ 'prior-authorization.form.procedure' | translate }} {{ i + 1 }}</h6>
          <button
            *ngIf="!readonlyMode"
            mat-icon-button
            color="warn"
            [disabled]="authForm.procedures.controls.length === 1" (click)="authForm.deleteProcedure(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'code', formGroup: procedureForm } }"></ng-template>
          <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'modifierCode1', formGroup: procedureForm } }"></ng-template>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'modifierCode2', formGroup: procedureForm } }"></ng-template>
          <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'modifierCode3', formGroup: procedureForm } }"></ng-template>
          <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'modifierCode4', formGroup: procedureForm } }"></ng-template>
        </div>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'description', formGroup: procedureForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'quantity', formGroup: procedureForm } }"></ng-template>
        <ng-template
          *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'quantityTypeCode', formGroup: procedureForm, codeValueMap: authForm.proceduresCodeValueMap } }">
        </ng-template>
        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <ng-template *ngTemplateOutlet="dateField; context: { $implicit: { prop: 'fromDate', formGroup: procedureForm } }"></ng-template>
          <ng-template *ngTemplateOutlet="dateField; context: { $implicit: { prop: 'toDate', formGroup: procedureForm } }"></ng-template>
        </div>
        <!-- <ng-template
          *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'qualifierCode', formGroup: procedureForm, codeValueMap: authForm.proceduresCodeValueMap } }">
        </ng-template> -->
        <ng-template
          *ngTemplateOutlet="codeValueSelect; context: { $implicit: { prop: 'revenueCode', formGroup: procedureForm, codeValueMap: authForm.proceduresCodeValueMap } }">
        </ng-template>
      </section>
    </ng-container>

    <div *ngIf="authForm.canAddProcedure && !readonlyMode" class="add-wrapper">
      <button
        mat-mini-fab
        color="primary"
        (click)="authForm.addProcedureRow()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </section>

  <section>
    <h5>{{ 'prior-authorization.form.renderingProviders' | translate }}</h5>

    <section>
      <h6>{{ 'prior-authorization.form.facility' | translate }}</h6>

      <mat-form-field *ngIf="!readonlyMode; else readonlyFacility" appearance="fill">
        <mat-label>
          {{ 'prior-authorization.form.facility' | translate }}
        </mat-label>
        <mat-select [formControl]="facilityControl">
          <mmx-searchable-select>
            <mat-option *ngFor="let option of renderingProviderFacilityOptions" [value]="option">
              {{ option.name }}
            </mat-option>
          </mmx-searchable-select>
        </mat-select>
      </mat-form-field>

      <ng-template #readonlyFacility>
        <mat-form-field appearance="fill">
          <mat-label>
            {{ 'common.facility' | translate }}
          </mat-label>
          <input matInput type="text" [value]="authForm.facilityForm.controls.lastName.value" readonly="true"/>
        </mat-form-field>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'npi', formGroup: authForm.facilityForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'taxId', formGroup: authForm.facilityForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'phone', formGroup: authForm.facilityForm } }"></ng-template>
      </ng-template>
    </section>

    <section *ngIf="!readonlyMode || renderingProviderControl.value" [formGroup]="authForm.renderingProviderForm">
      <h6>{{ 'prior-authorization.form.renderingProvider' | translate }}</h6>

      <mat-form-field *ngIf="!readonlyMode; else readonlyProvider" appearance="fill">
        <mat-label>{{ 'common.provider' | translate }}</mat-label>
        <mmx-resource-selector-input
          type="provider"
          [multiple]="false"
          [groupByType]="false"
          [required]="false"
          [formControl]="renderingProviderControl">
        </mmx-resource-selector-input>
      </mat-form-field>

      <ng-template #readonlyProvider>
        <mat-form-field appearance="fill">
          <mat-label>
            {{ 'common.provider' | translate }}
          </mat-label>
          <input matInput type="text" [value]="authForm.renderingProviderForm.controls.lastName.value" readonly="true"/>
        </mat-form-field>
      </ng-template>

      <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
        <mat-form-field *ngIf="!readonlyMode" appearance="fill">
          <mat-label>
            {{ 'prior-authorization.form.roleCode' | translate }}
          </mat-label>
          <mat-select formControlName="roleCode">
            <mmx-searchable-select>
              <mat-option [value]="null">{{ 'common.none' | translate }}</mat-option>
              <mat-option *ngFor="let value of authForm.otherRenderingProviderRoleCodes" [value]="value.code">
                {{ value.value }}
              </mat-option>
            </mmx-searchable-select>
          </mat-select>
        </mat-form-field>

        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'specialtyCode', formGroup: authForm.renderingProviderForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'npi', formGroup: authForm.renderingProviderForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'taxId', formGroup: authForm.renderingProviderForm } }"></ng-template>
        <ng-template *ngTemplateOutlet="textField; context: { $implicit: { prop: 'phone', formGroup: authForm.renderingProviderForm } }"></ng-template>
      </div>
    </section>
  </section>

  <section *ngIf="authForm.form.contains('providerNotes')" formArrayName="providerNotes">
    <h5>{{ 'prior-authorization.form.providerNotes' | translate }}</h5>

    <ng-container *ngFor="let noteForm of authForm.providerNotes.controls; let i = index">
      <section [formGroup]="noteForm">
        <div class="subtitle-wrapper">
          <h6>{{ 'prior-authorization.form.note' | translate }} {{ i + 1 }}</h6>
          <button mat-icon-button color="warn" (click)="authForm.deleteProviderNote(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <mat-form-field appearance="fill">
          <mat-label>
            {{ 'prior-authorization.form.message' | translate }}
          </mat-label>
          <textarea matInput type="text" formControlName="message"></textarea>
        </mat-form-field>
      </section>
    </ng-container>

    <div *ngIf="authForm.canAddProviderNote && !readonlyMode" class="add-wrapper">
      <button
        mat-mini-fab
        color="primary"
        (click)="authForm.addProviderNoteRow()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </section>
</form>

<ng-template #codeValueSelect let-data>
  <mat-form-field *ngIf="data.formGroup.controls[data.prop]" appearance="fill">
    <mat-label>
      {{ 'prior-authorization.form.' + data.prop | translate }}
    </mat-label>

    <ng-container *ngIf="!readonlyMode; else readonlySelect">
      <mat-select [formControl]="data.formGroup.controls[data.prop]">
        <mmx-searchable-select>
          <mat-option *ngFor="let value of data.codeValueMap[data.prop]" [value]="value.code">
            {{ value.value }}
          </mat-option>
        </mmx-searchable-select>
      </mat-select>
    </ng-container>

    <ng-template #readonlySelect>
      <input
        matInput
        type="text"
        [value]="getValueByCode(data.formGroup.controls[data.prop]?.value, data.codeValueMap[data.prop])"
        readonly="true"/>
    </ng-template>
  </mat-form-field>
</ng-template>

<ng-template #dateField let-data>
  <mat-form-field *ngIf="data.formGroup.controls[data.prop]" appearance="fill">
    <mat-label>
      {{ 'prior-authorization.form.' + data.prop | translate }}
    </mat-label>

    <ng-container *ngIf="!readonlyMode; else readonlyDate">
      <mmx-date-selector-input
        [formControl]="data.formGroup.controls[data.prop]"
        [required]="isRequired(data.formGroup.controls[data.prop])"
        autocomplete="off"
      ></mmx-date-selector-input>
    </ng-container>

    <ng-template #readonlyDate>
      <input
        matInput
        type="text"
        [value]="formatDateString(data.formGroup.controls[data.prop].value)"
        readonly="true"/>
    </ng-template>
  </mat-form-field>
</ng-template>

<ng-template #textField let-data>
  <ng-container *ngIf="!readonlyMode || data.formGroup.controls[data.prop]?.value">
    <mat-form-field *ngIf="data.formGroup.controls[data.prop]" appearance="fill">
      <mat-label>
        {{ 'prior-authorization.form.' + data.prop | translate }}
      </mat-label>
      <input matInput type="text" [formControl]="data.formGroup.controls[data.prop]" [readonly]="readonlyMode"/>
    </mat-form-field>
  </ng-container>
</ng-template>
